<template>
  <div class="edit">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item href="/user/userTrackList">学员跟踪记录</Breadcrumb-item>
        <Breadcrumb-item>添加跟踪记录-家长沟通确认记录-课顾</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <Form ref="form" :model="formValidate" :rules="ruleValidate" :label-width="90" class="form">
      <Row>
        <Col :sm="11" :md="4">
          <Form-item label="学生ID" prop="uid">
            <Input readonly v-model.number="formValidate.uid"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="学生姓名" prop="nickname">
            <Input readonly v-model="formValidate.nickname"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="课程顾问" prop="adviserName">
            <Input readonly v-model="formValidate.adviserName"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="学习导师" prop="studyAdviserName">
            <Input readonly v-model="formValidate.studyAdviserName"></Input>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
          <Form-item label="内容" prop="content">
            <span>&nbsp;&nbsp;是否教授录屏工具&nbsp;&nbsp;</span>
            <Checkbox v-model="formValidate.isBatchedTch" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            <span>&nbsp;&nbsp;是否教用电子教材&nbsp;&nbsp;</span>
            <Checkbox v-model="formValidate.isBatchedTime" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            <span>&nbsp;&nbsp;是否发送专属二维码&nbsp;&nbsp;</span>
            <Checkbox v-model="formValidate.isCheckedForeignTchTime" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            <span>&nbsp;&nbsp;是否知悉协议条款&nbsp;&nbsp;</span>
            <Checkbox v-model="formValidate.havaTellChineseLessonRule" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            <div></div>
            <span>&nbsp;&nbsp;是否告知请假规则&nbsp;&nbsp;</span>
            <Checkbox v-model="formValidate.havaTellLeaveRule" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            <span>&nbsp;&nbsp;是否确认教材授课顺序&nbsp;&nbsp;</span>
            <Checkbox v-model="formValidate.haveWebChat" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="11" :md="9">
          <Form-item label="下次联系日期" prop="nextHandlerTime">
            <Date-picker type="date" format="yyyy-MM-dd" @on-change="nextTimeDateChange"
              :value="formValidate.nextHandlerTime"></Date-picker>
          </Form-item>
        </Col>
        <Col :sm="11" :md="7">
          <Form-item label="下次联系人" prop="nextHandlerId">
            <Select v-model.number="formValidate.nextHandlerId" filterable>
              <Option v-for="item in nextHandler"
                :value="item.id" :key="item.id">{{ item.nickname }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
        <Form-item label="状态" prop="operateStatus">
          <Select v-model="formValidate.operateStatus">
            <Option value="0">未处理</Option>
            <Option value="1">已处理</Option>
          </Select>
        </Form-item>
        </Col>
      </Row>
      <Form-item>
        <Button type="primary" @click="handleSubmit()">提交</Button>
      </Form-item>
    </Form>
  </div>
</template>
<script>
  import dates from '@/tools/date/dates.js'
  export default {
    data () {
//      let $moment = this.$moment
      return {
        nextHandler: [],
        uidReadonly: false,
        formValidate: {
          id: '',
          uid: null,
          nickname: '',
          adviserName: '',
          studyAdviserName: '',
          content: '',
          nextHandlerTime: dates.today(),
          nextHandlerId: null,
          operateStatus: '0',
          isBatchedTch: '0',
          isBatchedTime: '0',
          isCheckedForeignTchTime: '0',
          havaTellChineseLessonRule: '0',
          havaTellLeaveRule: '0',
          haveWebChat: '0',
          haveTellRestTime: '0',
          havaTellLivingLessonRule: '0'
        },
        ruleValidate: {
          uid: [
            { type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' },
            { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' },
          ],
          content: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }
          ]
//          nextHandlerId: [
//            { type: 'number', required: true, message: '请选择下次联系人', trigger: 'blur' },
//          ]
        },
      }
    },
    created () {
    },
    mounted () {
      let self = this
      let row = self.$route.query.row
      self.formValidate.uid = row.uid
      self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
        self.formValidate.nickname = res.data.nickname
        self.formValidate.adviserName = res.data.adviserName
        self.formValidate.studyAdviserName = res.data.studyAdviserName
      })
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.nextHandler = res.data
      })

      this.getUserInfo()
    },
    methods: {
      nextTimeDateChange (value) {
        this.formValidate.nextHandlerTime = value
        console.log(this.formValidate.nextHandlerTime)
      },
      getUserInfo () {
        let self = this
        if (!self.formValidate.uid) {
          return
        }
        self.$http.post('/user/queryById', {'uid': self.formValidate.uid}).then(function (res) {
          if (!res || !res.data) {
            return
          }
          let user = res.data
          self.formValidate.nickname = user.nickname
          self.formValidate.adviserName = user.adviserName
          self.formValidate.studyAdviserName = user.studyAdviserName
        })
      },
      handleSubmit () {
        let self = this
        this.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }

          self.$http.post('/userTrack/comunicationWithParent', self.formValidate).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!')
              self.$router.push('/user/userTrackList')
            }
          })
        })
      },
      onChange () {
        var arr = []
        if (this.formValidate.isBatchedTch === '1') {
          arr.push('已确定绑定老师')
        } else {
          arr.push('未确定绑定老师')
        }
        if (this.formValidate.isBatchedTime === '1') {
          arr.push('已确定绑定时间')
        } else {
          arr.push('未确定绑定时间')
        }
        if (this.formValidate.isCheckedForeignTchTime === '1') {
          arr.push('已核对外教主课时')
        } else {
          arr.push('未核对外教主课时')
        }
        if (this.formValidate.havaTellChineseLessonRule === '1') {
          arr.push('已告知中教课上课规则')
        } else {
          arr.push('未告知中教课上课规则')
        }
        if (this.formValidate.havaTellLeaveRule === '1') {
          arr.push('已告知请假制度')
        } else {
          arr.push('未告知中教课上课规则')
        }
        if (this.formValidate.haveWebChat === '1') {
          arr.push('已加上家长微信')
        } else {
          arr.push('未加上家长微信')
        }
        if (this.formValidate.haveTellRestTime === '1') {
          arr.push('已告知自己的休息时间')
        } else {
          arr.push('未告知自己的休息时间')
        }
        if (this.formValidate.havaTellLivingLessonRule === '1') {
          arr.push('已告知直播课上课规则')
        } else {
          arr.push('未告知直播课上课规则')
        }
        this.formValidate.content = arr.join(' ')
        console.log(this.formValidate.content)
      }
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// ParentCommunicationAdviserRecords.vue?5de61648